import { withTypeSafeApiResult } from '@/packages/typesafe-result';

import {
  type IGetMetaRequest,
  type IGetMetaResponse,
  fetchGetMeta as fetchGetMetaApi,
} from '@/repositories/generated/shared/search-offers-index/v2/get-meta';

import { type IApplicationContext } from '@/microfrontends/filters/shared/types/applicationContext';
import { type ISearchMeta } from '@/microfrontends/filters/shared/types/searchMeta';

import { prepareSearchMetaData } from './mappers/prepareSearchMeta';

export const fetchGetMeta = withTypeSafeApiResult<IGetMetaRequest, IGetMetaResponse>(fetchGetMetaApi);

export async function fetchGetMetaSafe(
  context: IApplicationContext,
  parameters: IGetMetaRequest,
): Promise<ISearchMeta> {
  const meta = await fetchGetMeta(context, parameters);

  if (meta.isErr()) {
    context.logger.error(meta.Err, { degradation: 'Search meta' });
  }

  return meta.map(prepareSearchMetaData).unwrapOr(
    prepareSearchMetaData({
      data: {
        count: 0,
        fullUrl: '',
        fullUrlWithoutSeo: '',
        h1: '',
        mapUrl: '',
        redirectToOldForm: false,
        url: '',
      },
    }),
  );
}
